export default "__VITE_ASSET__90021891__"